var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntroducerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 24",
    style: {
      enableBackground: "new 0 0 21 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,7.1l-4.5,4.5c-0.6,0.6-1.5,0.6-2.1,0s-0.6-1.5,0-2.1l1.9-1.9H1.5C0.7,7.5,0,6.8,0,6s0.7-1.5,1.5-1.5 h14.4l-1.9-1.9c-0.6-0.6-0.6-1.5,0-2.1s1.5-0.6,2.1,0l4.5,4.5C21.1,5.5,21.1,6.5,20.6,7.1L20.6,7.1z M4.9,23.6l-4.5-4.5 c-0.6-0.6-0.6-1.5,0-2.1l4.5-4.5c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1l-1.9,1.9h14.4c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H5.1 l1.9,1.9c0.6,0.6,0.6,1.5,0,2.1C6.5,24.1,5.5,24.1,4.9,23.6L4.9,23.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroducerIcon);
export default __webpack_public_path__ + "static/media/Introducer_Icon.2c676a0ecdaabf944dc9ed1e5a6048ba.svg";
export { ForwardRef as ReactComponent };